exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sidebar {\r\n    position: fixed;\r\n}\r\n\r\n.logo {\r\n    height: 32px;\r\n    background: rgba(255, 255, 255, 0.2);\r\n    margin: 16px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    line-height: 32px;\r\n}\r\n\r\n.site-layout .site-layout-background {\r\n    background: #fff;\r\n}\r\n\r\n[data-theme=\"dark\"] .site-layout .site-layout-background {\r\n    background: #141414;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/containers/MainView.css
// module id = 3006
// module chunks = 0